// Domain color configurations
import { API_CONFIG } from '../../../config/api';

export const domainColors = {
  "Physical Development": {
    primary: "#D67C2C",
    light: "#E8F5E9",
    gradient: "linear-gradient(135deg, #43A047 0%, #66BB6A 100%)"
  },
  "Socio-Emotional Development": {
    primary: "#D67C2C",
    light: "#FFEBEE",
    gradient: "linear-gradient(135deg, #E53935 0%, #EF5350 100%)"
  },
  "Cognitive Development": {
    primary: "#D67C2C",
    light: "#E3F2FD",
    gradient: "linear-gradient(135deg, #1E88E5 0%, #42A5F5 100%)"
  },
  "Language & Literacy Development": {
    primary: "#D67C2C",
    light: "#F3E5F5",
    gradient: "linear-gradient(135deg, #8E24AA 0%, #AB47BC 100%)"
  },
  "Aesthetic & Cultural Development": {
    primary: "#D67C2C",
    light: "#FFF3E0",
    gradient: "linear-gradient(135deg, #FB8C00 0%, #FFA726 100%)"
  },
  "Positive Learning Habits": {
    primary: "#D67C2C",
    light: "#E0F2F1",
    gradient: "linear-gradient(135deg, #00897B 0%, #26A69A 100%)"
  }
};

// API Base URL
export const API_BASE_URL = API_CONFIG.BASE_URL;

// Domain config for UI elements
export const getDomainConfig = (domainNameRaw) => {
  const domainName = (domainNameRaw || "").toLowerCase();

  if (domainName.includes("physical")) {
    return {
      icon: <img src="https://cdn-icons-png.flaticon.com/512/18320/18320927.png" alt="Physical-Development"
        className="w-5 h-5" style={{ filter: "invert(1)" }} />,
      image: "https://images.pexels.com/photos/8430599/pexels-photo-8430599.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      gradient: "from-orange-400 to-red-500",
      color: "#FF7A59"
    };
  }
  if (domainName.includes("socio") || domainName.includes("emotional")) {
    return {
      icon: <img src="https://cdn-icons-png.flaticon.com/512/12649/12649548.png"
        alt="Socio-Emotional-Development" className="w-5 h-5" style={{ filter: "invert(1)" }} />,
      image: "https://images.pexels.com/photos/8385033/pexels-photo-8385033.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      gradient: "from-pink-400 to-orange-500",
      color: "#F17C45"
    };
  }
  if (domainName.includes("cognitive")) {
    return {
      icon: <img src="https://cdn-icons-png.flaticon.com/512/3288/3288930.png" alt="Cognitive-Development"
        className="w-5 h-5" style={{ filter: "invert(1)" }} />,
      image: "https://images.pexels.com/photos/7296429/pexels-photo-7296429.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      gradient: "from-blue-400 to-orange-500",
      color: "#1D3469"
    };
  }
  if (domainName.includes("literacy") || domainName.includes("language")) {
    return {
      icon: <img src="https://cdn-icons-png.flaticon.com/512/3898/3898150.png"
        alt="Language-Literacy-Development" className="w-5 h-5" style={{ filter: "invert(1)" }} />,
      image: "https://images.pexels.com/photos/8613121/pexels-photo-8613121.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      gradient: "from-green-400 to-orange-500",
      color: "#FF7A59"
    };
  }
  if (domainName.includes("aesthetic") || domainName.includes("cultural")) {
    return {
      icon: <img src="https://cdn-icons-png.flaticon.com/512/5730/5730993.png"
        alt="Aesthetic-Cultural-Development" className="w-5 h-5" style={{ filter: "invert(1)" }} />,
      image: "https://images.pexels.com/photos/8819206/pexels-photo-8819206.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      gradient: "from-purple-400 to-orange-500",
      color: "#F17C45"
    };
  }
  if (domainName.includes("positive") || domainName.includes("habit")) {
    return {
      icon: <img src="https://cdn-icons-png.flaticon.com/512/4310/4310163.png" alt="Positive-Learning-Habits"
        className="w-5 h-5" style={{ filter: "invert(1)" }} />,
      image: "https://images.pexels.com/photos/4546115/pexels-photo-4546115.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      gradient: "from-teal-400 to-orange-500",
      color: "#FF7A59"
    };
  }
  // fallback:
  return {
    icon: <img src="https://cdn-icons-png.flaticon.com/512/18320/18320927.png" alt="Physical-Development"
      className="w-5 h-5" style={{ filter: "invert(1)" }} />,
    image: "https://images.pexels.com/photos/8430599/pexels-photo-8430599.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    gradient: "from-orange-400 to-red-500",
    color: "#FF7A59"
  };
};

// CSS Animations
export const animations = `
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeIn 0.5s ease-out forwards;
}

.animate-fade-in-delay-1 {
  opacity: 0;
  animation: fadeIn 0.5s ease-out 0.1s forwards;
}

.animate-fade-in-delay-2 {
  opacity: 0;
  animation: fadeIn 0.5s ease-out 0.2s forwards;
}

.animate-fade-in-delay-3 {
  opacity: 0;
  animation: fadeIn 0.5s ease-out 0.3s forwards;
}

.animate-fade-in-delay-4 {
  opacity: 0;
  animation: fadeIn 0.5s ease-out 0.4s forwards;
}

.text-shadow {
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
`;